import SimulationStyles from './SimulationStyles';

export default {
  simulationStyles: [ 'type', SimulationStyles ]
};